import NumberFormat from 'react-number-format';
import React from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Label from '../Texts/Label/Label';
import Icon from '../Icon/Icon';
import Span from '../Texts/Span/Span';
import * as S from './FormattedAmountInput.styles';

const spanVariantByStatus = {
  normal: 'neutral',
  error: 'danger',
};

const FormattedAmountInput = ({
  name,
  label,
  message,
  onChange,
  onBlur,
  onFocus,
  onValueChange,
  disabled,
  placeHolder,
  decimalSeparator,
  decimalScale,
  thousandSeparator,
  prefix,
  status,
  value,
}) => {
  const [formattedAmountState, setFormattedAmountState] = useState({
    value,
  });

  return (
    <S.FormattedAmountInput status={status}>
      {label && (
        <Label type='2' htmlFor={name} align='center'>
          {label}
        </Label>
      )}
      <NumberFormat
        placeholder={placeHolder}
        isNumericString={true}
        decimalSeparator={decimalSeparator || ','}
        value={formattedAmountState.value}
        decimalScale={decimalScale || 2}
        fixedDecimalScale={true}
        thousandSeparator={thousandSeparator || '.'}
        prefix={prefix || '$'}
        onValueChange={(values) => {
          setFormattedAmountState({
            value: values.value,
          });
          onValueChange && onValueChange(values);
        }}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
      />
      {message && (
        <S.HelpText status={status}>
          {status === 'error' && (
            <Icon
              name='error_circle_outline'
              variant='danger'
              width={16}
              height={16}
            />
          )}
          <Span type='4' variant={spanVariantByStatus[status]}>
            {message}
          </Span>
        </S.HelpText>
      )}
    </S.FormattedAmountInput>
  );
};

FormattedAmountInput.defaultProps = {
  status: 'normal',
  disabled: false,
  value: '',
};

FormattedAmountInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  message: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  placeHolder: PropTypes.string,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
  thousandSeparator: PropTypes.string,
  prefix: PropTypes.string,
  status: PropTypes.oneOf(['normal', 'error']),
  value: PropTypes.string,
};

export default FormattedAmountInput;
